module.exports = __webpack_public_path__ + "static/media/survey_placeholder.503abbf5.png";